<script>
	// Stores
	import { 
		linkMapa,
		linkWaze,
		linkUber,
		linkAV, 
		linkAPI, 
		tagsSEO, 
		textEndereco, 
		textAtendimento, 
		textCNPJ, 
		textCreci, 
		textSite, 
		textTelefone, 
		linkTelefone,
		textWhatsappVendas, 
		linkWhatsappVendas,
		textWhatsappLocacao, 
		linkWhatsappLocacao,
		textWhatsappCondominio, 
		linkWhatsappCondominio,
		linkFacebook,
		linkInstagram,
		linkPoliticaPrivacidade
	} from '../store.js';

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	
	let social = [
		{
			title: 'Facebook',
			icon: '<i class="fab fa-2x fa-facebook-square"></i>',
			link: $linkFacebook,
			target: '_blank',
		},
		{
			title: 'Instagram',
			icon: '<i class="fab fa-2x fa-instagram"></i>',
			link: $linkInstagram,
			target: '_blank',
		},
	];

	let localizacao = [
		{
			title: 'Mapa',
			icon: '<i class="fal fa-2x fa-map-marked-alt"></i>',
			link: $linkMapa,
		},
		{
			title: 'Waze',
			icon: '<i class="fab fa-2x fa-waze"></i>',
			link: $linkWaze,
		},
		{
			title: 'Uber',
			icon: '<i class="fab fa-2x fa-uber"></i>',
			link: $linkUber,
		},
	];

	let contatos = [
		{
			title: 'Atendimento',
			icon: '<i class="fas fa-phone-volume"></i> ' + $textTelefone,
			href: $linkTelefone,
			target: '_blank'
		},
		{
			title: 'Vendas',
			icon: '<i class="fab fa-whatsapp"></i> ' + $textWhatsappVendas,
			href: $linkWhatsappVendas,
			target: '_blank'
		},
		{
			title: 'Aluguel',
			icon: '<i class="fab fa-whatsapp"></i> ' + $textWhatsappLocacao,
			href: $linkWhatsappLocacao,
			target: '_blank'
		},
		{
			title: 'Condomínio',
			icon: '<i class="fab fa-whatsapp"></i> ' + $textWhatsappCondominio,
			href: $linkWhatsappCondominio,
			target: '_blank'
		}
	];    
</script>

<section class="footer-banner">
	<div class="container">
		<div class="flex flex-center flex-wrap gap-10">
			{#each contatos as item}
			<div class="footer-banner__item">
				<b>{item.title}:</b>
				<a href="{item.href}" target="_blank">
					{@html item.icon}
				</a>
			</div>
			{/each}
		</div>
	</div>
</section>
<footer>
	<section class="informacoes">
		<div class="container">
			<div class="itens text-center">
				<div class="item text-lg-left">
					<img class="mb-10" src="/assets/images/logoFooter.png" border="0" alt="Logotipo" />
					<p>{@html $tagsSEO}</p>
					<div class="flex sm-flex-center gap-10">
						{#each social as item}
							<a class="flex flex-center" href="{item.link}" use:link replace title="Ir para {item.title}" target="{item.target}">{@html item.icon != null ? item.icon : ""}&nbsp;{item.title}</a>
						{/each}
					</div>
				</div>
				<div class="item">
					<h3><i class="far fa-clock color-accent"></i> ATENDIMENTO</h3>
					<p>{@html $textAtendimento}</p>
				</div>
				<div class="item text-lg-right">
					<h3><i class="far fa-map-marker color-accent"></i> ENDEREÇO</h3>
					<p>{@html $textEndereco}</p>
					<div class="flex flex-end sm-flex-center gap-10">
						{#each localizacao as item}
							<a class="flex flex-center" href="{item.link}" use:link replace title="Ir para {item.title}" target="_blank">{@html item.icon != null ? item.icon : ""}&nbsp;{item.title}</a>
						{/each}
					</div>

				</div>
			</div>
			<p class="copyright mt-30">
				<a href={$linkPoliticaPrivacidade} target="_blank" title="Política de Privacidade">- Política de Privacidade -</a>
				<br><br>
				© Copyright 2022 - {$textSite} - CRECI {$textCreci} - CNPJ {$textCNPJ} - Todos os Direitos Reservados - Desenvolvido por <a href="{$linkAPI}" target="_blank" title="API - Tecnologia digital resultados reais">API</a>
			</p>
		</div>
	</section>
</footer>
